export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./select-custom.vue?vue&type=template&id=b0bc4b1e&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/ui-components/select-custom/select-custom.vue?vue&type=template&id=b0bc4b1e&
// module id = 1345
// module chunks = 0